export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5151.e41b6da4.jpg";